import { ArrowPathIcon, ArrowUturnUpIcon } from "@heroicons/react/24/outline";

import { Button } from "@fronterahealth/frontera-ui-components/ui/button";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { CommentActionTooltip } from "@components/QaReview/components/CommentActionTooltip";
import { useReopenComment } from "@components/QaReview/hooks/useReopenComment";

interface CommentActionReopenProps {
  comment: ReviewItemFieldsFragment;
}

export const CommentActionReopen: React.FC<CommentActionReopenProps> = ({ comment }) => {
  const { reopen, isReopening } = useReopenComment();

  if (comment.__typename !== "ReportCommentType" || comment.status !== "resolved") return null;

  return (
    <CommentActionTooltip label="Mark this comment as open again">
      <Button
        variant="ghost"
        size="xs"
        onClick={(e) => {
          e.stopPropagation();
          reopen(comment);
        }}
        disabled={isReopening}
      >
        {isReopening ? (
          <ArrowPathIcon className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <ArrowUturnUpIcon className="h-3.5 w-3.5" />
        )}
        Reopen
      </Button>
    </CommentActionTooltip>
  );
};
